import React from 'react';
import { SitecoreImageField } from 'components/sitecore-fields';
import CustomEventLeaderboardInfoButton from './custom-event-leaderboard-info-button';

const CustomEventLeaderboardHeader = ({ logo, patronLogo }) => {
    return (
        <div className="custom-event-leaderboard__control-panel">
            <div className="custom-event-leaderboard__control-panel-col-1">
                <div className="custom-event-leaderboard__logo">
                    <SitecoreImageField img={logo} />
                </div>
            </div>
            <div className="custom-event-leaderboard__control-panel-col-2">
                <CustomEventLeaderboardInfoButton />
                <div className="custom-event-leaderboard__patron">
                    <SitecoreImageField img={patronLogo} />
                </div>
            </div>
        </div>
    );
};

export default CustomEventLeaderboardHeader;
